<script lang="ts">
    import {onMount} from "svelte";
    import {getTariffs, postTariff, retireTariff} from "$lib/calls/tariff";
    import {
        Button, Modal, Search, Spinner,
        Table,
        TableBody, TableBodyCell,
        TableBodyRow,
        TableHead,
        TableHeadCell, Toggle
    } from "flowbite-svelte";
    import PageLayout from "$lib/components/PageLayout.svelte";
    import {getUnits} from "$lib/calls/unit";
    import {EditSolid, FileCopySolid, PenSolid, PlusOutline} from "flowbite-svelte-icons";
    import {availableQualifications, unitQualifications} from "$lib/calls/qualification";
    import dayjs from "dayjs";
    import OpenButton from "$lib/components/ui/OpenButton.svelte";
    import TariffDetailsModal from "$lib/partials/settings/TariffDetailsModal.svelte";
    import RemoveButton from "$lib/components/ui/RemoveButton.svelte";
    import { fly } from "svelte/transition"
    import SortableTable from "$lib/components/SortableTable.svelte";
    import {allUnits} from "$lib/stores/unit";
    import {formatCurrency} from "$lib/utils/currency";
    import {tariffs} from "$lib/stores/tariffs";
    import TariffActionButtons from "$lib/partials/settings/TariffActionButtons.svelte";

    let possibleQualifications = []
    let loadedUnitQualifications: number[] = []
    let search = '';

    let loading = true;

    let currentTariff;
    let detailModal = false;
    const openDetailModal = tariff => {
        alert('Fremdgesteuert via \\TIMECOUNT')
        currentTariff = tariff;
        detailModal = true;
    }


    const header = () => ([
        {
            property: 'name',
            label: 'Name',
            sortable: true
        },
        {
            property: 'unitId',
            label: 'Unit',
            render: (row) => $allUnits.find(x => x.id === row.unitId)?.name || 'N/A',
            sortable: true,
            customSort: (a, b, c) => $allUnits.find(x => x.id === a.unitId)?.name < $allUnits.find(x => x.id === b.unitId)?.name ? c : -1 * c
        },
        {
            property: 'wagePerHour',
            label: 'Stundenlohn',
            render: (row) => `${formatCurrency(row.wagePerHour, 'EUR')}`,
        },
        {
            property: 'validFrom',
            label: 'Gültig ab',
            render: (row) => dayjs(row.validFrom.value).format('DD.MM.YYYY'),
            sortable: true
        },
        {
            property: 'visible',
            label: 'Sichtbar',
            render: (row) => row.visible ? 'Ja' : 'Nein',
            sortable: true
        },
        {
            property: 'id',
            label: 'Actions',
            component: TariffActionButtons,
            props: {
                qualifications: possibleQualifications
            }

        }
    ])

    onMount(async () => {
        if($tariffs.length === 0){
            $tariffs = await getTariffs();
        }
        if($allUnits.length === 0) {
            $allUnits = await getUnits();
        }
        $allUnits.forEach((unit: any) => {
            if(!loadedUnitQualifications.find(x => x === unit.id)){
                loadedUnitQualifications = [...loadedUnitQualifications, unit.id]
                unitQualifications(unit.id).then(res => {
                    possibleQualifications = [...possibleQualifications, ...res]
                })
            }
        })
        loading = false;
    })
</script>

<Search bind:value={search}/>
{#if !loading}
    <SortableTable data={$tariffs.filter(x => x.name.toLowerCase().includes(search.toLowerCase()))} header={header()} />

    <div class="flex justify-end mt-5">
        <Button on:click={() => openDetailModal({
            hoursPerDay: 7,
            workingDaysPerWeek: 3,
            qualifications: []
        })}>
            <PlusOutline size="xs" />
            <span class="pl-2">Neuer Tarif</span>
        </Button>
    </div>
{:else}
    <div class="mt-5 flex justify-center">
        <Spinner/>
    </div>
{/if}
